import type { FaireProductEntity } from "../../entity_types/product";

export const p_tvzzz53vey: FaireProductEntity = {
  token: "p_tvzzz53vey",
  type: "product",
  name: "Halloween Ghost Dumpling Toy - Assorted",
  brandToken: "b_h8vd5c4vfp",
  brandName: "Mochi Mob",
  imageUrl:
    "https://cdn.faire.com/fastly/5bcda9ce496641b873b37b282237c0478187faeda9fbccab893ec7833e023390.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cc366ae9bfefac6220d4ab2e298901ba6da44610c0efcb3cc49680559ba45f04.jpeg",
    "https://cdn.faire.com/fastly/910b79cefd9cfea638ed253153aff22da6099005551daf81cae21c8be20a642a.jpeg",
  ],
  priceDollars: 8.49,
  description:
    "1. Adorable Assorted Ghost Dumpling Designs Each toy features a cute ghost-inspired dumpling character in assorted styles and expressions. The playful Halloween theme makes every piece fun to collect and share.\n\n2. Soft & Satisfying to Squeeze Crafted from soft, flexible material, this squishy toy provides a relaxing squeeze and quickly returns to its original shape. It's designed for repeated sensory play and long-lasting enjoyment.\n\n3. Engaging Sensory Experience The soft tactile texture offers a satisfying hands-on activity that keeps little hands busy. Perfect for interactive play, fidgeting, and screen-free entertainment throughout the day.\n\n4. Compact & Portable Size Small and lightweight, this ghost dumpling toy easily fits into backpacks, lunch bags, treat bags, pockets, and purses. Take it anywhere for fun on the go.\n\n5. Perfect for Halloween Party Favors An excellent addition to Halloween parties, school celebrations, haunted houses, carnival prizes, and neighborhood trick-or-treat events. It also makes a fun non-candy giveaway.",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:32.752Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
